import { CXoneEvent }  from '@nice-ccf/common-sdk';
/**
 * Model class for activity
 */
export class SkillActivityEvent extends CXoneEvent {
  /**
   * @remarks  Count of available agents
   */
  public agentsAvailable!: number;

  /**
   * @remarks Count of unavailable agents
   */
  public agentsUnavailable!: number;

  /**
   * @remarks  Count of logged in agents
   */
  public agentsLoggedIn!: number;

  /**
   * @remarks  Count of working agents
   */
  public agentsWorking!: number;

  /**
   * @remarks  Unique identifier for Campaign
   */
  public campaignId!: number;

  /**
   * @remarks  EarliestQueueTime
   */
  public earliestQueueTime!: string;

  /**
   * @remarks  Agent Email Address
   */
  public emailFromAddress!: string;

  /**
   * @remarks  The number of contacts agents handled inside the specified service level threshold
   */
  public contactsHandledInSLA!: number;

  /**
   * @remarks  Indicates if agent is in Active state
   */
  public isActive!: boolean;

  /**
   * @remarks  Indicates if the Skill is Personal Connection
   */
  public isPersonalConnection!: boolean;

  /**
   * @remarks  Indicates whether the call is an Outbound or inbound.
   */
  public isOutbound!: boolean;

  /**
   * @remarks  Unique identifier for the type of media, chat is "3", phone is "4"
   */
  public mediaTypeId!: number;

  /**
   * @remarks  Name of media type
   */
  public mediaTypeName!: string;

  /**
   * @remarks  The number of contacts agents handled outside the specified service level threshold
   */
  public contactsHandledOutSLA!: number;

  /**
   * @remarks  Numbers of items in personal queue
   */
  public personalQueueCount!: number;

  /**
   * @remarks  Number of items in queue
   */
  public queueCount!: number;

  /**
   * @remarks  Service level set for the contact
   */
  public serviceLevel!: number;

  /**
   * @remarks  The minimum service level set by user per contact type
   */
  public serviceLevelGoal!: number;

  /**
   * @remarks Unique identifier for skill
   */
  public skillId!: number;

  /**
   * @remarks Name of the skill
   */
  public skillName!: string;

  /**
   * @remarks Number of skills in queue
   */
  public skillQueueCount!: number;

  /**
   * @remarks isRestricted
   */
  // public isRestricted: boolean;

  /**
   * This method to parse skill activity response
   * @param data -
   * @example -
   * ```
   * parse(data);
   * ```
   */
  parse(data: { [key: string]: any }): void {
    this.agentsAvailable = data.agentsAvailable;
    this.agentsUnavailable = data.agentsUnavailable;
    this.agentsLoggedIn = data.agentsLoggedIn;
    this.agentsWorking = data.agentsWorking;
    this.campaignId = data.campaignId;
    this.earliestQueueTime = data.earliestQueueTime;
    this.emailFromAddress = data.emailFromAddress;
    this.contactsHandledInSLA = data.inSLA;
    this.isActive = data.isActive;
    this.isPersonalConnection = data.isNaturalCalling;
    this.isOutbound = data.isOutbound;
    this.mediaTypeId = data.mediaTypeId;
    this.mediaTypeName = data.mediaTypeName;
    this.contactsHandledOutSLA = data.outSLA;
    this.personalQueueCount = data.personalQueueCount;
    this.queueCount = data.queueCount;
    this.serviceLevel = data.serviceLevel;
    this.serviceLevelGoal = data.serviceLevelGoal;
    this.skillId = data.skillId;
    this.skillName = data.skillName;
    this.skillQueueCount = data.skillQueueCount;
    //this.isRestricted = data.isRestricted;
  }
}
